module.exports = __webpack_public_path__ + "static/teaser-mobile-2-0806c599e81cd9e7e62c283a694db11b.png";